import type { VoteErrorCode } from "@shared/types";

/** An API error that preserves the structured fields the worker may attach to a
 * failed response (notably a vote-rejection `code` + the level numbers), so the
 * UI can render precise copy instead of parsing the message string. */
export class ApiError extends Error {
  readonly code?: VoteErrorCode;
  readonly requiredLevel?: number;
  readonly currentLevel?: number;

  constructor(message: string, opts?: { code?: VoteErrorCode; requiredLevel?: number; currentLevel?: number }) {
    super(message);
    this.name = "ApiError";
    this.code = opts?.code;
    this.requiredLevel = opts?.requiredLevel;
    this.currentLevel = opts?.currentLevel;
  }
}
